import blogAskTetaImage from "../../../assets/images/blog/blog-ask-teta.png";
import blogCustomersSuppliersImage from "../../../assets/images/blog/blog-customers-suppliers.png";
import blogDashboardImage from "../../../assets/images/blog/blog-dashboard.png";
import blogHeroImage from "../../../assets/images/blog/blog-hero.png";
import blogInventoryImage from "../../../assets/images/blog/blog-inventory.png";
import blogPaymentsImage from "../../../assets/images/blog/blog-payments.png";
import blogStoresImage from "../../../assets/images/blog/blog-stores.png";
import blogTeamImage from "../../../assets/images/blog/blog-team.png";

import type { BlogImageConfig } from "../types";

export const BLOG_HERO_IMAGE: BlogImageConfig = {
  src: blogHeroImage,
  altKey: "blog-image-hero-alt",
  altFallback: "Business owner working at a desk with a laptop"
};

/** Section id → image shown below the section heading (see `BLOG_SECTIONS` in blogContent). */
export const BLOG_SECTION_IMAGES: Record<string, BlogImageConfig> = {
  inventory: {
    src: blogInventoryImage,
    altKey: "blog-image-inventory-alt",
    altFallback: "Store team member scanning products on a shelf"
  },
  stores: {
    src: blogStoresImage,
    altKey: "blog-image-stores-alt",
    altFallback: "Row of retail storefronts representing multiple branches"
  },
  orders: {
    src: blogPaymentsImage,
    altKey: "blog-image-payments-alt",
    altFallback: "Cashier processing a customer payment at checkout"
  },
  dashboards: {
    src: blogDashboardImage,
    altKey: "blog-image-dashboard-alt",
    altFallback: "Tablet showing business analytics charts and KPIs"
  },
  "customers-suppliers": {
    src: blogCustomersSuppliersImage,
    altKey: "blog-image-customers-suppliers-alt",
    altFallback: "Business partners shaking hands in a warehouse"
  },
  "why-need": {
    src: blogTeamImage,
    altKey: "blog-image-team-alt",
    altFallback: "Team collaborating around a laptop in an office"
  },
  "ask-teta": {
    src: blogAskTetaImage,
    altKey: "blog-image-ask-teta-alt",
    altFallback: "Smartphone showing the Ask Teta AI assistant chat"
  }
};
